export default __webpack_public_path__ + "static/media/uport-medium.52d31511.png";